import React from "react"
import { Typography } from "@mui/material"
import { Product } from "@/shared/types/product"
import ProductListingCard, { EditableProductFields } from "@/features/listings/components/ProductListingCard"
import { ImageGalleryItem } from "@/shared/components/image-gallery"

interface Props {
  filteredProducts: Product[]
  pagedProducts: Product[]
  selectedIds: Set<string>
  onView: (items: ImageGalleryItem[], initialIndex: number) => void
  onDelete: (product: Product) => void
  onToggleSelect: (id: string) => void
  onRegenerateSame: (product: Product, imageIndex: number) => void
  onRegenerateDifferent: (product: Product, imageIndex: number) => void
  isRegenerating: (productId: string, imageIndex: number) => boolean
  regenerateDisabledReason?: string | null
  onUpdate: (productId: string, updates: EditableProductFields) => Promise<void>
  onPushToAmazon: (product: Product) => Promise<void>
  amazonPublishingAvailable: boolean
  canPublishToAmazon: boolean
}

const ListingsResults: React.FC<Props> = ({
  filteredProducts,
  pagedProducts,
  selectedIds,
  onView,
  onDelete,
  onToggleSelect,
  onRegenerateSame,
  onRegenerateDifferent,
  isRegenerating,
  regenerateDisabledReason,
  onUpdate,
  onPushToAmazon,
  amazonPublishingAvailable,
  canPublishToAmazon
}) => {
  if (filteredProducts.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" textAlign="center" py={4}>
        No products match your search.
      </Typography>
    )
  }

  return (
    <>
      {pagedProducts.map(product => (
        <ProductListingCard
          key={product.id}
          product={product}
          onView={onView}
          onDelete={onDelete}
          isSelected={selectedIds.has(product.id)}
          onToggleSelect={onToggleSelect}
          onRegenerateSame={onRegenerateSame}
          onRegenerateDifferent={onRegenerateDifferent}
          isRegenerating={isRegenerating}
          regenerateDisabledReason={regenerateDisabledReason}
          onUpdate={onUpdate}
          onPushToAmazon={onPushToAmazon}
          amazonPublishingAvailable={amazonPublishingAvailable}
          canPublishToAmazon={canPublishToAmazon}
        />
      ))}
    </>
  )
}

export default ListingsResults
